import { render, staticRenderFns } from "./transactionRecord.vue?vue&type=template&id=4c2f756a&scoped=true&"
import script from "./transactionRecord.vue?vue&type=script&lang=js&"
export * from "./transactionRecord.vue?vue&type=script&lang=js&"
import style1 from "./transactionRecord.vue?vue&type=style&index=1&id=4c2f756a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f756a",
  null
  
)

export default component.exports